module.exports = __webpack_public_path__ + "img/bg_s_8.bd96cd5e.png";